








































import Vue from 'vue';
import { IShoppingCartIndividual } from '@/common/interfaces/cart.interface';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import config from '../../../config';
import LimitingProductInfoList from '../limiting/product-info/LimitingProductInfoList.vue';
import ProductListDetails from './ProductListDetails.vue';
import ProductHelper from '../../helpers/ProductHelper';

interface IProductListListViewDetails {
  imageWidthInPixel: number;
  soldOutImage: string;
}

export default Vue.extend({
  name: `ProductListListViewDetails`,
  components: { LimitingProductInfoList, ProductListDetails },
  data(): IProductListListViewDetails {
    return {
      imageWidthInPixel: config.products.overviewImageWidthInPixel,
      soldOutImage: config.products.images.soldOut,
    };
  },
  computed: {
    discountOrSoldOutImage(): string {
      return ProductHelper.discountOrSoldOutImage(this.isPartner, this.product);
    },
  },
  props: {
    availableCarts: {
      required: true,
      type: Array as () => IShoppingCartIndividual[],
    },
    discountActive: {
      required: true,
      type: Boolean,
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
  },
});
